<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_EMAIL_CHANGE_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row" *ngIf="!isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <p class="page-subtitle">{{ 'COMMON_LBL_ERROR_MSG_NO_ACTIVE_LEASE' | translate }}</p>
            <p></p>
        </section>
        <section class="col-sm-2"></section>
    </div>
    <div class="row" *ngIf="isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                    <div class="row">
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_EMAIL_CHANGE_INPUT_EMAIL' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="emailAddress" name="emailAddress" 
                                [(ngModel)]="request.emailAddress"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.emailAddress.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                             
                                [pattern]="emailPattern" required maxlength="250"/>
                            <div *ngIf="formSubmitted && customForm.form.controls.emailAddress.invalid" class="text-danger">
                                <div *ngIf="customForm.form.controls.emailAddress.errors.pattern">{{ 'REQUEST_EMAIL_ERR_EMAIL_INVALID' | translate }}</div>
                            </div>
                        </section>
                    </div>
                    <div *ngIf="formSubmitted && customForm.invalid" class="row" style="margin: auto;">
                        <div class="col-sm-12 error-note">
                            <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>    
